import { todayDeliveryNum } from '@/utils/request'

export const statisticsDataMixin = {
  data () {
    return {
      statistics: {
        onSite: 0,
        running: 0, // 正在施工，包括中断和机修
        waiting: 0,
        overdue: 0,
        delay: 0,
        reworked: 0,
        interrupted: 0,
        enterToday: 0, // 进入进场
        dueToday: 0,
        todayDelivery: 0, // 今日完成
        dueTomorrow: 0, // 明日应交
        toDelivery: 0, // 待交车
        toSettle: 0 // 待结算
      }
    }
  },
  methods: {
    isRun (work) {
      return work.dispatchable && work.status.indexOf('RUN') !== -1
    },
    isWait (work) {
      if (work.status === 'WAIT_CONFIRM') return true
      return work.dispatchable && work.status.indexOf('WAIT') !== -1
    },
    isOverdue (work) {
      return new Date(work.estimateDeliveryTime.replace(/-/g, '/')).getTime() < new Date().getTime()
    },
    isEnterToday (work) {
      return new Date(work.enterTime.split(' ')[0].replace(/-/g, '/')).toDateString() === new Date().toDateString()
    },
    isDueToday (work) {
      return new Date(work.estimateDeliveryTime.split(' ')[0].replace(/-/g, '/')).toDateString() === new Date().toDateString()
    },
    isDueTomorrow (work) {
      const tomorrow = new Date()
      tomorrow.setDate(tomorrow.getDate() + 1)
      return new Date(work.estimateDeliveryTime.split(' ')[0].replace(/-/g, '/')).toDateString() === tomorrow.toDateString()
    }
  },
  computed: {
    allWorks () {
      return {
        beginWork: this.$store.state.work.beginWork,
        middleWorks: this.$store.state.work.middleWorks,
        endWorks: this.$store.state.work.endWorks
      }
    }
  },
  watch: {
    allWorks ({ beginWork, middleWorks, endWorks }) {
      if (!this.$store.state.work.loaded) return

      let onSite = beginWork.workList.length
      let running = 0
      let waiting = 0
      let overdue = 0
      let delay = 0
      let reworked = 0
      let interrupted = 0
      let enterToday = 0
      let dueToday = 0
      let dueTomorrow = 0
      let toDelivery = 0
      let toSettle = 0

      const workList = []

      beginWork.workList.forEach(work => {
        workList.push(work)
      })

      middleWorks.forEach(workColumns => {
        workColumns.forEach(workColumn => {
          onSite += workColumn.workList.length
          workColumn.workList.forEach(work => {
            workList.push(work)
          })
        })
      })
      endWorks.forEach(workColumn => {
        if (workColumn.type !== 'SETTLEMENT') {
          onSite += workColumn.workList.length
        }
        workColumn.workList.forEach(work => {
          workList.push(work)
        })
      })

      workList.forEach(work => {
        running += this.isRun(work) ? 1 : 0
        waiting += this.isWait(work) ? 1 : 0
        overdue += this.isOverdue(work) ? 1 : 0
        enterToday += this.isEnterToday(work) ? 1 : 0
        dueToday += this.isDueToday(work) ? 1 : 0
        dueTomorrow += this.isDueTomorrow(work) ? 1 : 0
        reworked += work.reworked ? 1 : 0
        interrupted += work.status === 'INTERRUPT' ? 1 : 0
        delay += work.delayed ? 1 : 0
        toDelivery += work.status === 'TO_DELIVER' ? 1 : 0
        toSettle += work.status === 'DELIVERED' ? 1 : 0
      })

      this.statistics.onSite = onSite
      this.statistics.running = running
      this.statistics.waiting = waiting
      this.statistics.overdue = overdue
      this.statistics.delay = delay
      this.statistics.reworked = reworked
      this.statistics.interrupted = interrupted
      this.statistics.enterToday = enterToday
      this.statistics.dueToday = dueToday
      this.statistics.dueTomorrow = dueTomorrow
      this.statistics.toDelivery = toDelivery
      this.statistics.toSettle = toSettle

      // 今日交车
      todayDeliveryNum().then(response => {
        this.statistics.todayDelivery = response.data
      })
    }
  }
}
